import React, { useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  tableCenter: {
    justifyContent: "center",
  },
}));

export default function ReferralTable(props) {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const headCells = [
    { label: "Transaction ID", id: "id" },
    { label: "Date et heure", id: "date" },
    // { label: "Client", id: "client" },
    { label: "Gain Parrainage", id: "earnings" },
  ];

  const listSuccessTransac = props.referralEarnings || []; // Use an empty array as fallback if referralEarnings is not provided

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, listSuccessTransac.length - page * rowsPerPage);

  return (
    <Grid>
      <Grid mt={3} item xs={12}>
        <h3>Détails de vos gains Parrainage :</h3>
      </Grid>

      <TableContainer>
        <Table
          sx={{
            boxShadow: 2,
            borderRadius: "10px",
            bgcolor: "#fff",
          }}
        >
          <TableHead>
            <TableRow>
              {headCells.map((headCells) => (
                <TableCell key={headCells.id}>{headCells.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {(rowsPerPage > 0
              ? listSuccessTransac.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : listSuccessTransac
            ).map((transaction, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{transaction.transaction_id}</TableCell>
                <TableCell>{transaction.created_at}</TableCell>
                {/* <TableCell>
                  {transaction.first_name} {transaction.last_name}
                </TableCell> */}
                <TableCell sx={{ fontWeight: "bold" }}>
                  {transaction.amount}€
                </TableCell>
              </TableRow>
            ))}

            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={5} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={listSuccessTransac.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  );
}
